module.exports = __webpack_public_path__ + "static/media/sofort_website.dde1cd5f.webp";